import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { skin, OemProps } from 'ui/styles/skin';
import { HorizontalSplitView } from 'ui/shared/SplitView';
import { persist } from 'ui/shared/persist';
import { MonitoringLayout } from './mainPanel/MonitoringLayout';
import { SidePanel } from './sidePanel/SidePanel';
import { timelinesRedraw } from 'actions/timelineActions';

const MonitoringPageSplitter = persist({
    storage: window.localStorage,
    key: 'monitoring-page',
})(HorizontalSplitView);

export class RawMonitoringPage extends React.Component<DispProps & OemProps> {
    resizeTimeoutId: NodeJS.Timer | null;

    componentDidMount() {
        if (window) {
            window.addEventListener('resize', this.onResize, false);
        }
    }

    componentWillUnmount() {
        if (this.resizeTimeoutId) {
            clearTimeout(this.resizeTimeoutId);
        }
        if (window) {
            window.removeEventListener('resize', this.onResize);
        }
    }

    onResize = () => {
        // Throttle resize calls to 5fps
        if ( !this.resizeTimeoutId ) {
            this.resizeTimeoutId = setTimeout(() => {
                this.resizeTimeoutId = null;
                this.props.onSplitChange();
            // tslint:disable-next-line
            }, 200) as any; // Note: shouldn't need to cast here but the tsconfig generated by CRA must be missing node definitions or something...
        }
    }
    
    render() {
        const { onSplitChange, styles } = this.props;
        return (
            <div id="monitoring-page" className="page" style={ styles.Workspace }>
                <MonitoringPageSplitter defaultValue=".25" min1={ 200 } min2={ 600 } onChange={ onSplitChange }>
                    <SidePanel/>
                    <MonitoringLayout/>
                </MonitoringPageSplitter>
            </div>
        );
    }
}

type DispProps = {
    onSplitChange: () => void;
};

const mapDispatchToProps = (dispatch: Function): DispProps => ({
    onSplitChange: () => dispatch(timelinesRedraw()),
});

export const MonitoringPage = compose<DispProps & OemProps, {}>(
    skin,
    connect<{}, DispProps, {}>(null, mapDispatchToProps),
)(RawMonitoringPage);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/MonitoringPage.tsx